import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=b44bd634"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\lifeline-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b44bd634')) {
      api.createRecord('b44bd634', component.options)
    } else {
      api.reload('b44bd634', component.options)
    }
    module.hot.accept("./Heading.vue?vue&type=template&id=b44bd634", function () {
      api.rerender('b44bd634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Heading.vue"
export default component.exports